const routes = [
  {
    path: '/',
    component: () => import('src/Layouts/QuasarLayout.vue'), // Using QuasarLayout as the main layout
    meta: {
      stylesheet: 'quasar'
    },
    redirect: '/crm',
    children: [
      {
        path: 'crm',
        component: () => import('src/Layouts/CRMLayout.vue'), // CRMLayout as child of QuasarLayout
        children: [
          {
            path: 'inventoryv2',
            name: 'inventoryv2-list',
            component: () => import('src/Pages/Admin/InventoryV2.vue')
          },
          {
            path: 'produktanfrage',
            name: 'product-request',
            component: () => import('src/Pages/Admin/ProductRequest.vue')
          },
          {
            path: 'customers',
            name: 'customers-list',
            component: () => import('src/Pages/Admin/Customers.vue')
          },
          {
            path: 'ordersv2',
            name: 'orders-listv2',
            component: () => import('src/Pages/Admin/OrderListV2.vue')
          },
          {
            path: 'orders/orderv2',
            name: 'orderv2',
            component: () => import('src/Pages/Admin/Single/Order2_0.vue')
          },
          {
            path: 'draftordersv2',
            name: 'draftorders-listv2',
            component: () => import('src/Pages/Admin/DraftOrdersV2.vue')
          },
          {
            path: 'providers',
            name: 'providers',
            component: () => import('src/Pages/Admin/Providers.vue')
          },
          // {
          //   path: 'invoices',
          //   name: 'invoices',
          //   component: () => import('src/Pages/Admin/Invoices.vue')
          // },
          {
            path: 'reports',
            name: 'reports',
            component: () => import('src/Pages/Admin/Reports.vue')
          },
          {
            path: 'settings',
            name: 'settings',
            component: () => import('src/Pages/Admin/Settings.vue')
          },
          {
            path: 'kpi-dashboard',
            name: 'kpi-dashboard',
            component: () => import('src/Pages/Admin/KPI.vue')
          },
          {
            path: 'import-csv',
            name: 'import-csv',
            component: () => import('src/Pages/Admin/ImportCSV.vue')
          },
          {
            path: 'pricing-tool',
            name: 'pricing-tool',
            component: () => import('src/Pages/Admin/PricingToolDashboard.vue')
          },
          {
            path: 'errors',
            name: 'crm.errors.index',
            component: () => import('src/Pages/Admin/Errors/IndexPage.vue')
          },
          {
            path: 'fast-bill/automation2',
            name: 'fast-bill-automation',
            component: () => import('src/Pages/Admin/FastBillAutomation.vue')
          },
          {
            path: 'shop',
            name: 'shop',
            component: () => import('src/Pages/Admin/Shop.vue')
          },
          // requiresCansativa: cannot be opened without the flag and a BtM number.
          {
            path: 'cansativa-orders',
            name: 'cansativa-orders',
            meta: { requiresCansativa: true },
            component: () => import('src/Pages/Admin/CansativaOrders.vue')
          },
          {
            path: 'cansativa-orders/:id',
            name: 'cansativa-order-detail',
            meta: { requiresCansativa: true },
            component: () => import('src/Pages/Admin/CansativaOrderDetail.vue')
          },
          {
            path: 'cansativa-cart',
            name: 'cansativa-cart',
            meta: { requiresCansativa: true },
            component: () => import('src/Pages/Admin/CansativaCart.vue')
          },

        ]
      },
      {
        path: 'auth',
        component: () => import('src/Layouts/AuthLayout.vue'), // AuthLayout as child of QuasarLayout
        children: [
          { path: '', name: 'Greeners', component: () => import('src/Pages/Index.vue') },
          { path: 'login', name: 'auth.login', component: () => import('src/Pages/Auth/SignIn.vue') },
          { path: 'passwort/zuruecksetzen', name: 'Passwort Zurücksetzen', component: () => import('src/Pages/Auth/PasswordReset.vue') },
          { path: 'passwort/anfordern', name: 'Passwort Anfordern', component: () => import('src/Pages/Auth/PasswordResetRequest.vue') },
        ]
      },
      {
         path: 'download',
         component: () => import('src/Pages/DownloadPharmacyProvider.vue'),
         children: [
                 { path: '', name: 'DownloadPharmacyProvider', component: () => import('src/Pages/Index.vue') },
         ]
      },
      {
        path: 'confirm-delivery/:id',
        component: () => import('src/Layouts/DeliveryLayout.vue'),
        children: [
          {
            path: '',
            name: 'confirmDelivery',
            component: () => import('src/Pages/SelectDelivery.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/stock-spreadsheet-mapping-dashboard',
    component: () => import('src/Layouts/BootstrapLayout.vue'), // Using BootstrapLayout for the new path
    meta: {
      stylesheet: 'bootstrap'
    },
    children: [
      {
        path: 'inventory-spreadsheet-mappings/create',
        name: 'stock-spreadsheet-mapping-dashboard.create',
        component: () => import('src/Pages/StockSpreadsheetMappingDashboard/InventorySpreadsheetMappings/CreatePage.vue')
      },
      {
        path: 'mapping-templates',
        component: () => import('src/Layouts/DummyLayout.vue'),
        children: [
          {
            path: '',
            name: 'mapping-templates.index',
            component: () => import('src/Pages/StockSpreadsheetMappingDashboard/MappingTemplates/IndexPage.vue')
          },
          {
            path: 'create',
            name: 'mapping-templates.create',
            component: () => import('src/Pages/StockSpreadsheetMappingDashboard/MappingTemplates/CreatePage.vue')
          },
          {
            path: 'edit/:id',
            name: 'mapping-templates.edit',
            component: () => import('src/Pages/StockSpreadsheetMappingDashboard/MappingTemplates/EditPage.vue'),
            props: true,
          },
        ]
      },
      {
        path: 'pharmacies',
        component: () => import('src/Layouts/DummyLayout.vue'),
        children: [
          {
            path: '',
            name: 'pharmacies.index',
            component: () => import('src/Pages/StockSpreadsheetMappingDashboard/Pharmacies/IndexPage.vue')
          },
          {
            path: 'edit/:id',
            name: 'pharmacies.edit',
            component: () => import('src/Pages/StockSpreadsheetMappingDashboard/Pharmacies/EditPage.vue'),
            props: true,
          }
        ]
      },
      {
        path: 'row-processing-templates',
        component: () => import('src/Layouts/DummyLayout.vue'),
        children: [
          {
            path: '',
            name: 'row-processing-templates.index',
            component: () => import('src/Pages/StockSpreadsheetMappingDashboard/RowProcessingTemplates/IndexPage.vue')
          },
          {
            path: 'create',
            name: 'row-processing-templates.create',
            component: () => import('src/Pages/StockSpreadsheetMappingDashboard/RowProcessingTemplates/CreatePage.vue')
          },
          {
            path: 'edit/:id',
            name: 'row-processing-templates.edit',
            component: () => import('src/Pages/StockSpreadsheetMappingDashboard/RowProcessingTemplates/EditPage.vue'),
            props: true,
          },
        ]
      },
      {
        'path': 'errors',
        'component': () => import('src/Layouts/DummyLayout.vue'),
        'children': [
          {
            'path': '',
            'name': 'errors.index',
            'component': () => import('src/Pages/StockSpreadsheetMappingDashboard/Errors/IndexPage.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('src/Pages/Error404.vue')
  }
]

export default routes
